// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"Video_col-md-4__w_4nm","mVideo":"Video_mVideo__bW_Sr","aVideo":"Video_aVideo__eQCzJ"};